import langTranslation from '../constants/translations';

const translations = (state = langTranslation, action) => {
    return state;
}

export default translations;

